import {Dispatch, SetStateAction, useCallback} from 'react';

import appService from '@/services/appService';
import authService from '@/services/auth/authService';
import log from '@/services/logger/log';
import pushNotificationService from '@/services/pushNotification/pushNotificationService';
import {hideLoader, showLoader} from '@/state/slices/loadersSlice';
import {dispatch} from '@/state/store';

import type {LoginErrorDetails} from '../LoginPageV2.types';

export interface LoginCredentials {
    username: string;
    password: string;
}

const usePasswordLoginHandler = (
    setLoginError: Dispatch<SetStateAction<LoginErrorDetails>>
): ((credentials: LoginCredentials) => Promise<void>) =>
    useCallback(
        async (credentials: LoginCredentials): Promise<void> => {
            setLoginError(null);
            // @ts-ignore
            dispatch(showLoader());

            try {
                await authService.login(credentials);
                await appService.fetchConsumerData();
                await pushNotificationService.checkSubscriptionInfoForNewUser();
            } catch (e) {
                setLoginError({});
                log.error(`LoginPageV2: passwordLogin, ${e}`);
            }

            // @ts-ignore
            dispatch(hideLoader());
        },
        [setLoginError]
    );

export default usePasswordLoginHandler;
